import { Component, Inject } from '@angular/core';
import { ProcessoService } from '@app/services/processo.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { Paginacao } from '@app/models/util/paginacao';
import { ToastrService } from 'ngx-toastr';
import debounce from '@app/utils/debounce';
import { Processo } from '@app/models/processo.model';


@Component({
  selector: 'app-consultar-anexos',
  templateUrl: './consultar-anexos.component.html',
  styleUrls: ['./consultar-anexos.component.scss']
})
export class ConsultarAnexosComponent {

  pesquisando: boolean = false;
  carregado: boolean = false;
  filtroDescricao = '';
  _pagina = 1;

  lstAnexo: Array<ProcessoAnexo> = [];

  paginacao: Paginacao = new Paginacao(1, 0, 5, 10);
  private _debounce: any;


  constructor(
    private processoService: ProcessoService,
    private utilitarioService: UtilitarioService,
    private relatorioService: RelatorioService,
    @Inject(ToastrService) private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.obterTodos('', 1);
  }

  pesquisar(){
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  onKeyPress = (event: KeyboardEvent) => {
    if (this.filtroDescricao.length >= 3 || this.filtroDescricao.length == 0) {
      this.obterTodos(this.filtroDescricao, 1);
    }
    this.paginacao.paginaAtual = 1;
  }
  
  obterTodos(filtroDescricao: string, pagina: number){
    this._pagina = pagina;

    this.relatorioService.obterAnexos(filtroDescricao, pagina)
      .toPromise().then(data => {
      this.lstAnexo = data.Dados;
      this.paginacao.totalDeItens = data.Total;
      this.pesquisando = false;
      this.carregado = true;
    },
    erro => {
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  retornaTipoMov(tipoMov: number): string {
    switch (tipoMov) {
      case 1: return 'Administrativa';
      case 2: return 'Execução Provisória';
      case 3: return 'Judicial';
      default: return '';
    }
  }

  obterArquivo(id: number): void {
    this.processoService.obterSasUrlParaDownloadMovimentacaoAnexo(id).toPromise().then((uriString) => {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.href = uriString;
      a.protocol = "https";
      a.click();
      a.remove();
    });
  }

  public pageChanged(event: any): void {
    this._pagina = event.page; 
    this.obterTodos(this.filtroDescricao,  this._pagina);  }
}
